<template>
  <Button variant="outline" class="" @click="onClick" :disabled="disabled || downloading" :title="title">
    <LayupSpinner v-if="downloading" />
    <Download v-else class="h-4 w-4" />
    {{ label }}
  </Button>
</template>

<script setup lang="ts">
import LayupSpinner from '@/components/common/LayupSpinner.vue';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-vue-next';

defineProps<{
  downloading: boolean;
  disabled: boolean;
  title: string;
  label: string;
  onClick: () => void;
}>();
</script>
